import Locator from '../Locator';
import LocatorSelect from '../LocatorSelect';
import FirmsAndCraftsmen from '../FirmsAndCraftsmen';
import SalesPlaces from '../SalesPlaces';
import Contacts from '../Contacts';

export default {
    path: '/lokator',
    component: Locator,
    children: [
        {
            path: 'realizacni-firmy-a-remeslnici',
            name: 'locator.firmsAndCraftsmen',
            component: FirmsAndCraftsmen,
            meta: {title: 'Realizační firmy a řemeslníci'},
            children: [
                {
                    path: 'vyhledat',
                    name: 'locator.firmsAndCraftsmen.search',
                    component: FirmsAndCraftsmen
                },
            ]
        },
        {
            path: 'prodejni-mista',
            name: 'locator.salesPlaces',
            component: SalesPlaces,
            meta: {title: 'Prodejní místa'},
            children: [
                {
                    path: 'vyhledat',
                    name: 'locator.salesPlaces.search',
                    component: SalesPlaces
                },
            ]
        },
        {
            path: 'kontakty',
            name: 'locator.contacts',
            component: Contacts,
            meta: {title: 'Kontakty'},
            children: [
                {
                    path: 'vyhledat',
                    name: 'locator.contacts.search',
                    component: Contacts
                },
            ]
        },
        {
            path: '',
            name: 'locator.select',
            component: LocatorSelect
        }
    ]
}



// WEBPACK FOOTER //
// ./src/components/locator/router/index.js